import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Panel } from 'primereact/panel'
import { ProgressBar } from 'primereact/progressbar'

import {
  Btn,
  CustomDropdown,
  CustomMultiSelect,
  InputText,
  PageHeader,
  Periodo,
  TextBtn,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import usePainelVeiculosEmRota, { LOAD_MESSAGE } from './PainelVeiculosEmRotaHook'
import ModalDetalhesVeiculo from './ModalDetalhesVeiculo'
import './PainelVeiculosEmRota.css'

function PainelVeiculosEmRota({ dispatch, history, selectedTp }) {
  const { state, localDispatch, ORDENAR_OPTIONS } = usePainelVeiculosEmRota(selectedTp)

  // Extrai lista única de empresas de todos os veículos
  const empresasOptions = React.useMemo(() => {
    const empresasSet = new Set()
    ;(state.veiculos || []).forEach(v => {
      if (Array.isArray(v.companies)) {
        v.companies.forEach(c => empresasSet.add(c))
      }
    })
    return Array.from(empresasSet)
      .sort()
      .map(c => ({ label: c, value: c }))
  }, [state.veiculos])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.FETCHING_DATA:
      case LOAD_MESSAGE.FETCHING_ENTREGAS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Para o auto refresh quando sair da tela
  useEffect(() => {
    return () => {
      localDispatch.stopAutoRefresh()
    }
  }, [])

  // Restaura modal após retorno da tela de canhoto
  useEffect(() => {
    const locationState = history.location.state
    if (!locationState || !locationState.restoreModal) return
    history.replace(history.location.pathname, {})
    const { fleet_id, pInicial, pFinal } = locationState.restoreModal
    localDispatch.onRestoreFromHistory(fleet_id, pInicial, pFinal)
  }, [])

  const temDados = state.entregas !== null

  return (
    <>
      <PageHeader>1.7 - Painel - Veículos em Rota</PageHeader>
      <div style={{ marginTop: 16, minHeight: '80vh' }}>
        <Panel header={<TextBtn onClick={history.goBack}>Voltar</TextBtn>}>
          <div style={{ marginBottom: 5, color: '#14B0BF' }}>Data Envio para Rota:</div>
          <div className="p-grid p-align-center">
            <div className="p-col-12 p-lg-6">
              <Periodo
                periodoInicial={state.pInicial}
                periodoFinal={state.pFinal}
                onPesquisar={(pInicial, pFinal) => localDispatch.onBtnPesquisar(pInicial, pFinal)}
              />
            </div>
          </div>

          {temDados && (
            <>
              {/* Seção Entregas */}
              <div className="painel-veiculos__secao-entregas">
                <div className="painel-veiculos__entregas-resumo">
                  <div className="painel-veiculos__entregas-titulo">ENTREGAS</div>
                  <div className="painel-veiculos__entregas-items">
                    <div className="painel-veiculos__entrega-item">
                      <div className="painel-veiculos__entrega-valor">
                        {state.entregas.nao_apuradas}
                      </div>
                      <div className="painel-veiculos__entrega-label">NÃO APURADAS</div>
                    </div>
                    <div className="painel-veiculos__entrega-item">
                      <div className="painel-veiculos__entrega-valor">
                        {state.entregas.entregues}
                      </div>
                      <div className="painel-veiculos__entrega-label">ENTREGUES</div>
                    </div>
                    <div className="painel-veiculos__entrega-item">
                      <div className="painel-veiculos__entrega-valor">
                        {state.entregas.devolucao_total}
                      </div>
                      <div className="painel-veiculos__entrega-label">DEVOLUÇÃO TOTAL</div>
                    </div>
                    <div className="painel-veiculos__entrega-item">
                      <div className="painel-veiculos__entrega-valor">
                        {state.entregas.devolucao_parcial}
                      </div>
                      <div className="painel-veiculos__entrega-label">DEVOLUÇÃO PARCIAL</div>
                    </div>
                    <div className="painel-veiculos__entrega-item">
                      <div className="painel-veiculos__entrega-valor">
                        {state.entregas.reentrega}
                      </div>
                      <div className="painel-veiculos__entrega-label">RE-ENTREGA</div>
                    </div>
                  </div>
                </div>

                <div className="painel-veiculos__entregas-atrasadas">
                  <div className="painel-veiculos__atrasadas-titulo">ENTREGAS ATRASADAS</div>
                  <div className="painel-veiculos__atrasadas-items">
                    <div className="painel-veiculos__atrasada-item">
                      <div className="painel-veiculos__atrasada-valor">
                        {state.entregasAtrasadas.mais_3_dias}
                      </div>
                      <div className="painel-veiculos__atrasada-label">+ 3 dias</div>
                    </div>
                    <div className="painel-veiculos__atrasada-item">
                      <div className="painel-veiculos__atrasada-valor">
                        {state.entregasAtrasadas.mais_7_dias}
                      </div>
                      <div className="painel-veiculos__atrasada-label">+ 7 dias</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Seção Veículos */}
              <div className="painel-veiculos__secao-veiculos">
                <div className="painel-veiculos__veiculos-resumo">
                  <div className="painel-veiculos__veiculos-titulo">VEÍCULOS</div>
                  <div className="painel-veiculos__veiculos-items">
                    <div className="painel-veiculos__veiculo-item">
                      <div className="painel-veiculos__veiculo-valor">
                        {state.total.total_veiculos || 0}
                      </div>
                      <div className="painel-veiculos__veiculo-label">TOTAL VEÍCULOS</div>
                    </div>
                    <div className="painel-veiculos__veiculo-item">
                      <div className="painel-veiculos__veiculo-valor">
                        {state.total.veiculos_finalizados || 0}
                      </div>
                      <div className="painel-veiculos__veiculo-label">VEÍCULOS FINALIZADOS</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Filtros */}
              <div className="p-grid p-align-center" style={{ marginTop: 20 }}>
                <div className="p-col-12 p-lg-4">
                  <InputText
                    label="Pesquisar:"
                    value={state.searchText}
                    onChange={value => localDispatch.onSearchTextChange(value)}
                    placeholder="Rota, placa, motorista, data ou cliente..."
                  />
                </div>
                <div className="p-col-12 p-lg-4">
                  <CustomDropdown
                    showLabel={true}
                    label="Ordenar Por:"
                    optionLabel="label"
                    options={ORDENAR_OPTIONS}
                    value={state.ordenarPor}
                    onChange={value => localDispatch.onOrdenarPorChange(value)}
                    placeholder="Selecione..."
                  />
                </div>
                <div
                  className="p-col-12 p-lg-4"
                  style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}
                >
                  <div style={{ flex: 1 }}>
                    <CustomMultiSelect
                      label="Empresas"
                      optionLabel="label"
                      options={empresasOptions}
                      value={state.empresasSelecionadas}
                      onChange={value => localDispatch.onEmpresasSelecionadasChange(value)}
                      filterPlaceholder="Buscar empresa..."
                    />
                  </div>
                  <Btn onClick={() => localDispatch.onLimparFiltros()}>Limpar Filtros</Btn>
                </div>
              </div>

              {/* Cards dos Veículos */}
              <div className="painel-veiculos__cards-container">
                {state.veiculosFiltrados.map(veiculo => (
                  <VeiculoCard
                    key={veiculo.fleet_id}
                    veiculo={veiculo}
                    onClick={() => localDispatch.onVeiculoCardClick(veiculo)}
                  />
                ))}
                {state.veiculosFiltrados.length === 0 && (
                  <div className="painel-veiculos__empty-message">
                    Nenhum veículo encontrado para os filtros aplicados
                  </div>
                )}
              </div>
            </>
          )}
        </Panel>
      </div>

      {/* Modal de Detalhes do Veículo */}
      <ModalDetalhesVeiculo
        visible={!!state.modalVeiculo}
        veiculo={state.modalVeiculo}
        entregas={state.entregasModal}
        onClose={localDispatch.onModalClose}
        history={history}
        pInicial={state.pInicial}
        pFinal={state.pFinal}
      />
    </>
  )
}

// Componente do Card do Veículo
function VeiculoCard({ veiculo, onClick }) {
  const getProgressBarColor = percent => {
    if (percent === 100) return '#28a745' // verde
    return '#dc3545' // vermelho
  }

  return (
    <div className="painel-veiculos__card" onClick={onClick}>
      <div className="painel-veiculos__card-info">
        <div className="painel-veiculos__card-data">Rota: {veiculo.fleet_id}</div>
        <div className="painel-veiculos__card-placa">{veiculo.vehicle_badge}</div>
        <div className="painel-veiculos__card-motorista">{veiculo.driver_name}</div>
        <div className="painel-veiculos__card-data">Data de Envio: {veiculo.sent_time}</div>
      </div>

      <div className="painel-veiculos__card-progress">
        <div className="painel-veiculos__progress-item">
          <span className="painel-veiculos__progress-label">Status Final</span>
          <div className="painel-veiculos__progress-bar-container">
            <ProgressBar
              value={veiculo.percentual_status_final}
              showValue={false}
              style={{
                height: '20px',
                backgroundColor: '#e0e0e0',
              }}
              color={getProgressBarColor(veiculo.percentual_status_final)}
            />
            <span className="painel-veiculos__progress-value">
              {veiculo.percentual_status_final}%
            </span>
          </div>
        </div>
        <div className="painel-veiculos__progress-item">
          <span className="painel-veiculos__progress-label">Status Canhoto</span>
          <div className="painel-veiculos__progress-bar-container">
            <ProgressBar
              value={veiculo.percentual_canhoto}
              showValue={false}
              style={{
                height: '20px',
                backgroundColor: '#e0e0e0',
              }}
              color={getProgressBarColor(veiculo.percentual_canhoto)}
            />
            <span className="painel-veiculos__progress-value">{veiculo.percentual_canhoto}%</span>
          </div>
        </div>
      </div>

      <div className="painel-veiculos__card-stats">
        <div className="painel-veiculos__stat-item">
          <div className="painel-veiculos__stat-valor">{veiculo.qte_entregas}</div>
          <div className="painel-veiculos__stat-label">Qte Entregas</div>
        </div>
        <div className="painel-veiculos__stat-item">
          <div className="painel-veiculos__stat-valor">{veiculo.qte_com_falta}</div>
          <div className="painel-veiculos__stat-label">Saiu com Falta</div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    selectedTp: state.system.selectedTp,
  }
}

export default connect(mapStateToProps)(withRouter(PainelVeiculosEmRota))
